import {
  createFocusHandle,
  createOnBlur,
  FilterInputProps,
  FocusRef,
  InfiniteSearchSelect,
  registerTableFilter,
  useInfiniteSearchRolesQuery,
} from '@atlas-frontend/sdk';
import { FilterFn } from '@tanstack/react-table';
import { forwardRef, useCallback, useImperativeHandle, useMemo } from 'react';
import styled from 'styled-components';

declare module '@tanstack/react-table' {
  interface FilterFns {
    roleIds: FilterFn<any>;
  }
}

export const RoleInfiniteFilterInput = forwardRef<FocusRef, FilterInputProps>(
  (
    {
      onBlur,
      header: {
        column: { id: columnId, getFilterValue, setFilterValue },
      },
    },
    ref,
  ) => {
    const id = `${columnId}-filter-input`;
    const value = (getFilterValue() as number[] | undefined) ?? [];

    useImperativeHandle(ref, () => createFocusHandle(id));
    const handleBlur = useMemo(
      () => createOnBlur<HTMLDivElement>(id, onBlur),
      [id, onBlur],
    );
    const handleChange = useCallback(
      (nextValue: number[]) => {
        setFilterValue(nextValue.length ? nextValue : undefined);
      },
      [setFilterValue],
    );

    return (
      <SelectWrapper
        id={id}
        allowClear
        autoFocus
        className={id}
        defaultOpen
        searchOptions={{ selectedIds: value }}
        mode="multiple"
        onBlur={handleBlur}
        onChange={handleChange}
        useSearchHook={useInfiniteSearchRolesQuery}
        value={value}
      />
    );
  },
);

registerTableFilter('roleIds', () => true, RoleInfiniteFilterInput);

const SelectWrapper = styled(InfiniteSearchSelect<number[]>)`
  width: 260px;
`;
